import Component, {
  AddPositionFormProps,
} from 'components/PositionsList/AddPositionForm/AddPositionForm';
import { withStatus } from 'hoc/Status/Status';

const AddPositionForm = withStatus<AddPositionFormProps>(Component);

export default AddPositionForm;
